import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api-config/axios";

export const getAllTracks = createAsyncThunk("tracks/get", async () => {
  const res = await api.get("/api/v1/tracks");
  return res.data;
});

export const getTrack = createAsyncThunk("track/get", async (trackId) => {
  const res = await api.get(`/api/v1/tracks/${trackId}`);
  return res.data;
});
